export const RayLayer1 = () => {
  return (
    <>
      <svg width="1366" height="768" viewBox="0 0 1366 768" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.2" clipPath="url(#clip0_5973_9066)" filter="url(#filter0_f_5973_9066)">
          <path d="M578.909 -308H787.487L719.38 270.908H647.016L578.909 -308Z" fill="url(#paint0_linear_5973_9066)" />
          <path d="M787.485 1066.51H578.908L647.014 487.605H719.378L787.485 1066.51Z" fill="url(#paint1_linear_5973_9066)" />
          <path d="M132.35 -30.291L279.836 -177.777L641.028 279.731L589.859 330.9L132.35 -30.291Z" fill="url(#paint2_linear_5973_9066)" />
          <path d="M279.837 936.29L132.351 788.804L589.86 427.613L641.029 478.781L279.837 936.29Z" fill="url(#paint3_linear_5973_9066)" />
          <path d="M1086.16 -177.777L1233.65 -30.2908L776.141 330.9L724.972 279.732L1086.16 -177.777Z" fill="url(#paint4_linear_5973_9066)" />
          <path d="M893.964 -273.947L944.143 -255.683L729.76 282.349L712.351 276.013L893.964 -273.947Z" fill="url(#paint5_linear_5973_9066)" />
          <path d="M467.333 1035.36L417.154 1017.1L631.537 479.065L648.946 485.401L467.333 1035.36Z" fill="url(#paint6_linear_5973_9066)" />
          <path d="M417.154 -255.683L467.332 -273.946L648.946 276.013L631.537 282.35L417.154 -255.683Z" fill="url(#paint7_linear_5973_9066)" />
          <path d="M944.143 1017.1L893.965 1035.36L712.351 485.401L729.76 479.065L944.143 1017.1Z" fill="url(#paint8_linear_5973_9066)" />
          <path d="M1252.73 559.255L1234.77 609.543L695.446 398.423L701.676 380.976L1252.73 559.255Z" fill="url(#paint9_linear_5973_9066)" />
          <path d="M1263.98 151.721L1279.74 202.74L721.483 356.97L716.014 339.269L1263.98 151.721Z" fill="url(#paint10_linear_5973_9066)" />
          <path d="M122.362 641.497L102.161 592.067L644.644 389.209L651.652 406.358L122.362 641.497Z" fill="url(#paint11_linear_5973_9066)" />
          <path d="M108.544 131.57L132.034 83.6149L644.253 353.931L636.103 370.568L108.544 131.57Z" fill="url(#paint12_linear_5973_9066)" />
          <path d="M1233.65 788.804L1086.16 936.291L724.97 478.782L776.139 427.613L1233.65 788.804Z" fill="url(#paint13_linear_5973_9066)" />
          <path d="M1366.39 270.909V479.486L787.486 411.379V339.016L1366.39 270.909Z" fill="url(#paint14_linear_5973_9066)" />
          <path d="M0 479.486L0 270.908L578.908 339.015V411.379L0 479.486Z" fill="url(#paint15_linear_5973_9066)" />
          <g filter="url(#filter1_f_5973_9066)">
            <ellipse cx="683.395" cy="378.757" rx="186" ry="186.5" fill="#FFFACF" />
          </g>
        </g>
        <defs>
          <filter id="filter0_f_5973_9066" x="-4" y="-308" width="1374" height="1374" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_5973_9066" />
          </filter>
          <filter id="filter1_f_5973_9066" x="437.395" y="132.257" width="492" height="493" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="30" result="effect1_foregroundBlur_5973_9066" />
          </filter>
          <linearGradient id="paint0_linear_5973_9066" x1="683.198" y1="-308" x2="683.198" y2="270.909" gradientUnits="userSpaceOnUse">
            <stop offset="0.165441" stopColor="#FFFACF" stopOpacity="0" />
            <stop offset="1" stopColor="#FFFACF" />
          </linearGradient>
          <linearGradient id="paint1_linear_5973_9066" x1="683.196" y1="1066.51" x2="683.196" y2="487.605" gradientUnits="userSpaceOnUse">
            <stop offset="0.165441" stopColor="#FFFACF" stopOpacity="0" />
            <stop offset="1" stopColor="#FFFACF" />
          </linearGradient>
          <linearGradient id="paint2_linear_5973_9066" x1="206.093" y1="-104.034" x2="615.443" y2="305.316" gradientUnits="userSpaceOnUse">
            <stop offset="0.165441" stopColor="#FFFACF" stopOpacity="0" />
            <stop offset="1" stopColor="#FFFACF" />
          </linearGradient>
          <linearGradient id="paint3_linear_5973_9066" x1="206.094" y1="862.547" x2="615.444" y2="453.197" gradientUnits="userSpaceOnUse">
            <stop offset="0.165441" stopColor="#FFFACF" stopOpacity="0" />
            <stop offset="1" stopColor="#FFFACF" />
          </linearGradient>
          <linearGradient id="paint4_linear_5973_9066" x1="1159.91" y1="-104.034" x2="750.556" y2="305.316" gradientUnits="userSpaceOnUse">
            <stop offset="0.165441" stopColor="#FFFACF" stopOpacity="0" />
            <stop offset="1" stopColor="#FFFACF" />
          </linearGradient>
          <linearGradient id="paint5_linear_5973_9066" x1="919.054" y1="-264.815" x2="721.055" y2="279.181" gradientUnits="userSpaceOnUse">
            <stop offset="0.165441" stopColor="#FFFACF" stopOpacity="0" />
            <stop offset="1" stopColor="#FFFACF" />
          </linearGradient>
          <linearGradient id="paint6_linear_5973_9066" x1="442.243" y1="1026.23" x2="640.242" y2="482.233" gradientUnits="userSpaceOnUse">
            <stop offset="0.165441" stopColor="#FFFACF" stopOpacity="0" />
            <stop offset="1" stopColor="#FFFACF" />
          </linearGradient>
          <linearGradient id="paint7_linear_5973_9066" x1="442.243" y1="-264.814" x2="640.241" y2="279.182" gradientUnits="userSpaceOnUse">
            <stop offset="0.165441" stopColor="#FFFACF" stopOpacity="0" />
            <stop offset="1" stopColor="#FFFACF" />
          </linearGradient>
          <linearGradient id="paint8_linear_5973_9066" x1="919.054" y1="1026.23" x2="721.055" y2="482.233" gradientUnits="userSpaceOnUse">
            <stop offset="0.165441" stopColor="#FFFACF" stopOpacity="0" />
            <stop offset="1" stopColor="#FFFACF" />
          </linearGradient>
          <linearGradient id="paint9_linear_5973_9066" x1="1243.75" y1="584.399" x2="698.561" y2="389.7" gradientUnits="userSpaceOnUse">
            <stop offset="0.165441" stopColor="#FFFACF" stopOpacity="0" />
            <stop offset="1" stopColor="#FFFACF" />
          </linearGradient>
          <linearGradient id="paint10_linear_5973_9066" x1="1271.86" y1="177.231" x2="718.748" y2="348.119" gradientUnits="userSpaceOnUse">
            <stop offset="0.165441" stopColor="#FFFACF" stopOpacity="0" />
            <stop offset="1" stopColor="#FFFACF" />
          </linearGradient>
          <linearGradient id="paint11_linear_5973_9066" x1="112.261" y1="616.782" x2="648.148" y2="397.784" gradientUnits="userSpaceOnUse">
            <stop offset="0.165441" stopColor="#FFFACF" stopOpacity="0" />
            <stop offset="1" stopColor="#FFFACF" />
          </linearGradient>
          <linearGradient id="paint12_linear_5973_9066" x1="120.289" y1="107.592" x2="640.178" y2="362.25" gradientUnits="userSpaceOnUse">
            <stop offset="0.165441" stopColor="#FFFACF" stopOpacity="0" />
            <stop offset="1" stopColor="#FFFACF" />
          </linearGradient>
          <linearGradient id="paint13_linear_5973_9066" x1="1159.9" y1="862.547" x2="750.554" y2="453.197" gradientUnits="userSpaceOnUse">
            <stop offset="0.165441" stopColor="#FFFACF" stopOpacity="0" />
            <stop offset="1" stopColor="#FFFACF" />
          </linearGradient>
          <linearGradient id="paint14_linear_5973_9066" x1="1366.39" y1="375.197" x2="787.486" y2="375.197" gradientUnits="userSpaceOnUse">
            <stop offset="0.165441" stopColor="#FFFACF" stopOpacity="0" />
            <stop offset="1" stopColor="#FFFACF" />
          </linearGradient>
          <linearGradient id="paint15_linear_5973_9066" x1="0" y1="375.197" x2="578.909" y2="375.197" gradientUnits="userSpaceOnUse">
            <stop offset="0.165441" stopColor="#FFFACF" stopOpacity="0" />
            <stop offset="1" stopColor="#FFFACF" />
          </linearGradient>
          <clipPath id="clip0_5973_9066">
            <rect width="1366" height="1366" fill="white" transform="translate(0 -304)" />
          </clipPath>
        </defs>
      </svg>

    </>
  )
}
